import React, { useEffect, useState } from 'react';

// @ts-ignore
import styles from './QuestionnaireConfirmExportModal.module.scss';
import Button from '../../../../Components/Button/Button';
import Modal from '../../../../Components/Modal/Modal';
import { Size } from '../../../../Enums/Size.enum';
import useTranslation from '../../../../Hooks/useTranslation';
import { useTreatmentContext } from '../../../../Services/TreatmentContext';
import { Theme } from '../../../../Enums/Theme.enum';
import { useQuestionnaireResultsQuery } from '../../../../graphql/graphql';
import Loading from '../../../../Components/Loading';
import Checkbox from '../../../../Components/Base/Checkbox/Checkbox';
import InputWrapper from '../../../../Components/Form/components/InputWrapper/InputWrapper';
import { getMomentDate } from '../../../../Utils/dates.util';
import { useAppContext } from '../../../../Services/AppContext';
import Text from '../../../../Components/Base/Text/Text';

interface QuestionnaireConfirmExportModalProps {
	isOpen: boolean;
	onClose: () => void;
	onConfirm: (resultIds: string[], withEvaluation: boolean) => void;
	questionnaireCode: string;
	patientId: string;
}
const QuestionnaireConfirmExportModal: React.FC<
	QuestionnaireConfirmExportModalProps
> = ({ onClose, onConfirm, isOpen, questionnaireCode, patientId }) => {
	const { isCase } = useTreatmentContext();
	const { t } = useTranslation();
	const { dateFormatMoment } = useAppContext();
	const { data, isLoading } = useQuestionnaireResultsQuery({
		questionnaireCode: questionnaireCode,
		patientId: patientId,
	});
	const [resultsIds, setResultsIds] = useState<string[]>([]);
	const [withEvaluation, setWithEvaluation] = useState<boolean>(false);

	const handleAddId = (questionnaireResultId: string, state: boolean) => {
		if (state) {
			setResultsIds(prev => prev.filter(item => item != questionnaireResultId));
		} else {
			setResultsIds(prev => [...prev, questionnaireResultId]);
		}
	};

	if (isLoading) {
		return <Loading />;
	}

	return (
		<Modal opened={isOpen} onClose={onClose} wrapChat={isCase} size={Size.SM}>
			<Modal.Header title={'component.questionnaireExportModal.title'} />
			<Modal.Content>
				<div className={styles.wrapper}>
					<Text
						tx='component.questionnaireExportModal.hint'
						className={styles.text}
					/>
					<div className={styles.checkboxes}>
						{data?.questionnaireResults?.data?.map(item => {
							const val = resultsIds?.some((id: string) => id === item?.id);
							if (item?.id) {
								return (
									<InputWrapper key={item.id}>
										<Checkbox
											value={val}
											tx={
												getMomentDate(item?.createdAt).format(
													dateFormatMoment,
												) +
												' - ' +
												item?.questionnaire?.title
											}
											onChange={() => handleAddId(item.id, val)}
										/>
									</InputWrapper>
								);
							}
						})}
					</div>
					<Text
						tx='component.questionnaireExportModal.withEvaluationHint'
						className={styles.text2}
					/>
					<Checkbox
						tx='component.questionnaireExportModal.withEvaluation'
						value={withEvaluation}
						onChange={() => setWithEvaluation(!withEvaluation)}
					/>
					<Text
						tx='component.questionnaireExportModal.text'
						className={styles.text}
					/>
					<div className={styles.buttonsWrapper}>
						<Button
							onClick={() => onConfirm(resultsIds, withEvaluation)}
							title={'base.export'}
							theme={Theme.GREEN}
						/>
					</div>
				</div>
			</Modal.Content>
		</Modal>
	);
};

export default QuestionnaireConfirmExportModal;
